<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card invoice">
          <!-- Card header -->
          <div class="pb-0 card-header invoice">
            <div class="d-flex justify-content-between align-items-start align-items-md-center flex-wrap olt-controls-row">
              <div class="d-flex flex-wrap align-items-center gap-1">
                <span
                  class="badge mx-1 bg-dark cursor-pointer"
                  @click="setStatusFilter('')"
                  :class="{ 'border border-light': statusFilter === '' && reasonFilter === '' }"
                  >Total {{ data.length }}</span
                >
                <span
                  class="badge mx-1 bg-dark text-white cursor-pointer"
                  @click="setStatusFilter('online')"
                  :class="{ 'border border-success': statusFilter === 'online' }"
                >
                  <span
                    class="inline-block bg-success rounded-circle"
                    style="
                      height: 0.5rem;
                      width: 0.5rem;
                      display: inline-block;
                      margin-right: 0.25rem;
                    "
                  ></span>
                  Online
                  {{
                    data.filter((item) => item.status_is == "online")
                      .length
                  }}
                </span>
                <span
                  class="badge mx-1 bg-dark text-white cursor-pointer"
                  @click="setStatusFilter('offline')"
                  :class="{ 'border border-danger': statusFilter === 'offline' }"
                >
                  <span
                    class="inline-block bg-danger rounded-circle"
                    style="
                      height: 0.5rem;
                      width: 0.5rem;
                      display: inline-block;
                      margin-right: 0.25rem;
                    "
                  ></span>
                  Offline
                  {{
                    data.filter((item) => item.status_is == "offline")
                      .length
                  }}
                </span>
                <span
                  class="badge mx-1 bg-dark cursor-pointer"
                  @click="setReasonFilter('OLT no response')"
                  :class="{ 'border border-light': reasonFilter === 'OLT no response' }"
                  >OLT no response
                  {{
                    data.filter(
                      (item) => item.last_dereg_reason == "OLT no response"
                    ).length
                  }}</span
                >
                <span
                  class="badge mx-1 bg-dark cursor-pointer"
                  @click="setReasonFilter('Fiber-Down')"
                  :class="{ 'border border-light': reasonFilter === 'Fiber-Down' }"
                  >Fiber-Down
                  {{
                    data.filter(
                      (item) => item.last_dereg_reason == "Fiber-Down"
                    ).length
                  }}</span
                >
                <span
                  class="badge mx-1 bg-dark cursor-pointer"
                  @click="setReasonFilter('Power-OFF')"
                  :class="{ 'border border-light': reasonFilter === 'Power-OFF' }"
                  >Power-OFF
                  {{
                    data.filter(
                      (item) => item.last_dereg_reason == "Power-OFF"
                    ).length
                  }}</span
                >

                 <button v-if="selected_olt && selected_olt !== ''" class="badge denger-bg text-xs mx-2 p-2 cursor-pointer align-middle" @click="showConfirm = true">
                   CLEAR
                  </button>
                <select v-if="selected_olt && selected_olt !== ''"
                  class="form-control invoice dark-filter w-auto"
                  style="width: auto; min-width: 180px; max-width: 260px;"
                  v-model="selectedSync"
                >
                  <option value="">Sync All</option>
                  <option
                    v-for="(items, index) in sync_list"
                    :key="index"
                    :value="items.code"
                  >
                    {{ items.desc }}
                  </option>
                </select>
                <button v-if="selected_olt && selected_olt !== ''"
                  class="badge bg-secondary text-xs mx-2 p-2 cursor-pointer align-middle"
                  :disabled="syncing"
                  @click="handleSync"
                  style="margin-left: 8px;"
                >
                  <span v-if="syncing">Syncing...</span>
                  <span v-else>Sync</span>
                </button>
                <div v-if="syncMessage" class="text-success my-2">{{ syncMessage }}</div>
                    <select
                      @change="handleOltData()"
                      v-model="selected_olt"
                      class="form-control invoice dark-filter w-auto"
                      style="width: auto; min-width: 180px; max-width: 240px;"
                      name="filter"
                      id="filter"
                    >
                      <option value="" selected disabled hidden>OLT</option>
                      <option value="">All</option>
                      <option
                        v-for="item in filterOlt"
                        :key="item.olt_name"
                        :value="item.id"
                      >
                        {{ item.olt_name }}
                      </option>
                    </select>
                    <select
                      @change="handlePortData(selected_port)"
                      v-model="selected_port"
                      v-if="port_olt[0]"
                      class="form-control invoice dark-filter w-auto"
                      style="width: auto; min-width: 140px; max-width: 200px;"
                      name="filter"
                      id="filter"
                    >
                      <option value="" selected disabled hidden>PORT</option>
                      <option value="">All</option>
                      <option
                        v-for="item in port_olt[0]?.PORT"
                        :key="item"
                        :value="item"
                      >
                        {{ item }}
                      </option>
                    </select>
                     <input
                    type="text"
                    v-model="searchQuery"
                    class="form-control invoice w-auto"
                     style="width: auto; min-width: 140px; max-width: 200px;"
                    placeholder="Search..."
                  />
                   
              </div>

              
              <!-- Sync and Clear functionality - only show when specific OLT is selected -->
              <!-- <div v-if="selected_olt && selected_olt !== ''" class="d-flex align-items-center flex-wrap gap-2">

                 
              </div> -->
              
              
            </div>
          </div>

          <div class="px-0 pb-0 card-body invoice rounded-0">
            <div class="table-responsive" v-if="data && data.length > 0">
              <table id="users-list" class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      @click="sort('olt_connect')"
                      :class="{
                        asc: sortKey === 'olt_connect' && sortOrder === 'asc',
                        desc: sortKey === 'olt_connect' && sortOrder === 'desc',
                      }"
                    >
                      OLT<span class="sort-icon"> </span>
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      @click="sort('port_number')"
                      :class="{
                        asc: sortKey === 'port_number' && sortOrder === 'asc',
                        desc: sortKey === 'port_number' && sortOrder === 'desc',
                      }"
                    >
                      PON NO. <span class="sort-icon"> </span>
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      @click="sort('vendor')"
                      :class="{
                        asc: sortKey === 'vendor' && sortOrder === 'asc',
                        desc: sortKey === 'vendor' && sortOrder === 'desc',
                      }"
                    >
                      Vendor <span class="sort-icon"> </span>
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      @click="sort('distance')"
                      :class="{
                        asc: sortKey === 'distance' && sortOrder === 'asc',
                        desc: sortKey === 'distance' && sortOrder === 'desc',
                      }"
                    >
                      Distance <span class="sort-icon"> </span>
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      @click="sort('PPPOE_ID')"
                      :class="{
                        asc: sortKey === 'PPPOE_ID' && sortOrder === 'asc',
                        desc: sortKey === 'PPPOE_ID' && sortOrder === 'desc',
                      }"
                    >
                      DESCRIPTION <span class="sort-icon"> </span>
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      @click="sort('status')"
                      :class="{
                        asc: sortKey === 'status' && sortOrder === 'asc',
                        desc: sortKey === 'status' && sortOrder === 'desc',
                      }"
                    >
                      STATUS <span class="sort-icon"> </span>
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      @click="sort('description')"
                      :class="{
                        asc: sortKey === 'description' && sortOrder === 'asc',
                        desc: sortKey === 'description' && sortOrder === 'desc',
                      }"
                    >
                      RX POWER <span class="sort-icon"> </span>
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      @click="sort('TXPower')"
                      :class="{
                        asc: sortKey === 'TXPower' && sortOrder === 'asc',
                        desc: sortKey === 'TXPower' && sortOrder === 'desc',
                      }"
                    >
                      Tx POWER <span class="sort-icon"> </span>
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      ONU INFO <span class="sort-icon"> </span>
                    </th>

                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody class="text-sm">
                  <!-- Use paginatedData instead of filteredData -->
                  <tr v-for="(item, index) in paginatedData" :key="index">
                    <td>{{ item.olt_connect }}</td>
                    <td>
                      {{ item.port_number }}
                      <span
                        class="badge rounded-pill"
                        style="background-color: #28c76f !important"
                      >
                        {{ item.Temperature_onu }} °C
                      </span>
                    </td>
                    <td>{{ item.vendor }}</td>
                    <td>{{ item.distance }}</td>
                    <td>
                      Pppoe Users
                      <template v-if="hasPermission('2023')">
                      <i
                        @click="setEdit(item)"
                        class="fas fa-edit mx-2 cursor-pointer"
                        style="color: gray; font-size: 14px; color: #70d930"
                      ></i>
                      <i
                        @click="deletePopup(item.id)"
                        class="fas fa-trash-alt mx-2 cursor-pointer"
                        style="color: red; font-size: 12px"
                      ></i>
                      </template>
                      <br />
                      <span
                        v-for="(item_str, index) in formatdata(item.PPPOE_ID) ??
                        []"
                        :key="index"
                        class="mx-3s"
                        >&nbsp;&nbsp;&nbsp;&nbsp;
                        <router-link
                          v-if="item_str"
                          class="dark-filter"
                          :to="{ name: 'Graph', params: { pppoe: item_str } }"
                          >*{{ item_str }}</router-link
                        >
                        <br
                      /></span>
                    </td>
                    <td>
                      <p
                        class="badge"
                        :style="{
                          backgroundColor:
                            item.status_is == 'online'
                              ? item.bgcolor
                              : item.bgcolor,
                        }"
                      >
                        {{ item.status_is }}
                      </p>
                    </td>
                    <!-- <td class="align-items-center">
                  <div class="badge" :style="`background-color: ${item.bgcolor};`">
                      <p>
                           <sub class="badge" style="background-color:  green; margin-right: 5px; font-size:8px">{{ item.description_message?.value }}</sub>
                          <span style="color: white!important;">{{ item.description }}</span>
                          <sup class="badge" style="background-color:  green; margin-left: 5px;"><sup>{{ item.Temperature_onu }} °C</sup></sup>
                      </p>
                  </div>
              </td> -->
                    <td>
                      <span
                        class="position-relative badge"
                        :style="`background-color: #DFF7E9 !important;height: 30px;`"
                      >
                        <p style="color: #28c76f !important">
                          {{ item.description }}
                        </p>
                        <span
                          class="position-absolute top-0 start-100 translate-middle badge rounded-pill"
                          :style="`background-color: ${item.description_message?.color} !important;`"
                        >
                          {{ item.description_message?.value }}
                        </span>
                      </span>
                    </td>

                    <td>{{ item.TXPower }}</td>
                    <td>
                      <ul>
                        <li>Onu Id: {{ item.port_number }}</li>
                        <li>Mac: {{ item.mac_address }}</li>
                        <li>Last Dereg Time:</li>
                        <li>Last Dereg Reason: {{ item.last_dereg_reason }}</li>
                      </ul>
                    </td>

                    <td>
                      <a
                        @click="
                          Reset(item.port_number, item.olt_connect__id, index)
                        "
                        class="actionButton cursor-pointer pt-6 me-3"
                        data-bs-toggle="tooltip"
                        title="Reboot"
                      >
                        <span
                          v-if="reset_load && load_index == index"
                          class="spinner-border spinner-border-sm mx-3"
                        ></span>
                        <svg
                          v-else
                          style="width: 20px; color: gray"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 512 512"
                        >
                          <path
                            d="M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H352c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32s-32 14.3-32 32v35.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V432c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352H160c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1"
                            fill="#808080"
                          />
                        </svg>
                      </a>
                      <a
                        @click="
                          getResetData(
                            item.port_number,
                            item.olt_connect__id,
                            index
                          )
                        "
                        class="actionButton deleteButton cursor-pointer pt-6"
                        data-bs-toggle="tooltip"
                        title="Get"
                      >
                        <span
                          v-if="data_load && load_index == index"
                          class="spinner-border spinner-border-sm mx-3"
                        ></span>
                        <svg
                          v-else
                          style="width: 20px; color: gray"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 512 512"
                        >
                          <!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
                          <path
                            d="M64 32C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM64 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
                            fill="#808080"
                          />
                        </svg>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
              <Skalaton />
            </div>
            <div class="pagination-container">
              <button
                class="btn btn-sm btn-success mx-3 mt-3"
                @click="previousPage"
                :disabled="currentPage === 1"
              >
                Previous
              </button>
              <span class="mx-2"
                >Page {{ currentPage }} of {{ totalPages }}</span
              >
              <button
                class="btn btn-sm btn-success mx-3 mt-3"
                @click="nextPage"
                :disabled="currentPage === totalPages"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 text-end" v-if="epon_popup">
      <div class="popup_bg"></div>
      <div id="myModal" class="modal_class">
        <div class="modal-content invoice" style="max-width: 400px !important">
          <div class="d-flex justify-content-between">
            <span>Update Data</span>
            <span @click="popup_close" class="close">&times;</span>
          </div>

          <div class="hover-popup my-3">
            <div class="popup-content">
              <div class="row justify-content-center">
                <div class="mb-3 p-3">
                  <div class="col-12 col-sm-12 mb-3">
                    <div>
                      <textarea
                        v-model="formData.PPPOE_ID"
                        type="textarea"
                        rows="4"
                        placeholder="PPPOE ID"
                        class="form-control invoice-card"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-sm-12 mb-3">
                    <div>
                      <input
                        v-model="formData.port_number"
                        type="text"
                        placeholder="Port Number"
                        class="form-control invoice-card"
                      />
                    </div>
                  </div>
                </div>
                <div class="flex text-center">
                  <div class="grid grid-cols-2 gap-2">
                    <button class="btn btn-secondary mx-3" @click="popup_close">
                      Cancel
                    </button>
                    <button class="btn btn-success" @click="submitForm">
                      Update
                      <span
                        v-if="loading"
                        class="spinner-border spinner-border-sm mx-3"
                      ></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-6 text-end" v-if="delete_popup">
      <div class="popup_bg"></div>
      <div id="myModal" class="modal_class">
        <div class="modal-content invoice p-4 shadow-lg rounded">
          <div class="d-flex justify-content-center align-items-center mb-3">
            <h5 class="text-center m-0">Are you sure?</h5>
          </div>
          <div class="text-center">
            <button @click="deleteItem" class="btn btn-danger w-40 mx-1">
              Yes, delete it!
            </button>
            <button @click="popup_close" class="btn btn-success w-40 mx-1">
              No, keep it
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Clear Confirmation Modal (match OltDetails) -->
    <div v-if="showConfirm">
      <div class="popup_bg"></div>
      <div class="modal_class">
        <div class="modal-content invoice" style="width:25vw">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="font-weight-bold">Confirm Clear</span>
            <span @click="showConfirm = false" class="close">&times;</span>
          </div>
          <div class="my-3">
            Are you sure you want to clear this OLT data?
          </div>
          <div class="d-flex justify-content-end" style="gap: 10px;">
            <button class="btn btn-secondary btn-sm" @click="showConfirm = false">Cancel</button>
            <button class="btn btn-danger btn-sm" @click="confirmClear" :disabled="clearing">
              <span v-if="clearing">Clearing...</span>
              <span v-else>Clear</span>
            </button>
          </div>
        </div>
      </div>
    </div>
 
    <!-- Sync Status Modal (match OltDetails) -->
    <div v-if="showSyncStatus">
      <div class="popup_bg"></div>
      <div class="modal_class">
        <div class="modal-content invoice" style="width:25vw" :style="syncStatusMsg && syncStatusMsg.status === 'error'
          ? 'border: 3px solid #dc3545 !important;'
          : syncStatusMsg && (syncStatusMsg.status === 'running' || syncStatusMsg.status === 'success' || syncStatusMsg.status === 'finished')
          ? 'border: 3px solid #28a745 !important;'
          : ''">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="font-weight-bold">Sync Status</span>
            <span @click="showSyncCloseConfirm = true" class="close">&times;</span>
          </div>
          <div class="my-3" style="word-break: break-all;">
            <div v-if="syncStatusHistory.length" class="text-lg-center">
              <div v-for="(msg, idx) in syncStatusHistory" :key="idx" class="d-flex align-items-center mb-2" style="gap: 8px;">
                <!-- All previous statuses: always green check (complete) -->
                <span v-if="idx !== syncStatusHistory.length - 1">
                  <i class="fas fa-check-circle" style="color: #28a745;"></i>
                </span>
                <!-- Latest status: show real status -->
                <span v-else>
                  <i v-if="msg.status === 'success' || msg.status === 'finished'" class="fas fa-check-circle" style="color: #28a745;"></i>
                  <i v-else-if="msg.status === 'error'" class="fas fa-times-circle" style="color: #dc3545;"></i>
                  <span v-else-if="msg.status === 'running'" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                </span>
                <span>
                  <b>Status:</b> {{ msg.status }}
                  <span v-if="msg.message"> - {{ msg.message }}</span>
                  <!-- Show countdown if latest and finished -->
                  <span v-if="idx === syncStatusHistory.length - 1 && msg.status === 'finished' && syncStatusCountdown !== null">
                    <i>Closing in {{ syncStatusCountdown }} second<span v-if="syncStatusCountdown !== 1">s</span>Waiting 10 minutes before sync...<span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span></i>
                  </span>
                </span>
              </div>
            </div>
            <div v-else>
              {{ syncStatusMsg }}
            </div>
          </div>
          <div class="d-flex justify-content-end" style="gap: 10px;">
            <template v-if="syncStatusMsg && syncStatusMsg.status === 'error'">
              <button class="btn btn-danger btn-sm" @click="async () => { await getData(selected_olt); showSyncStatus = false; }">Reload Page</button>
              <button class="btn btn-secondary btn-sm" @click="showSyncCloseConfirm = true">Close</button>
            </template>
            <template v-else>
              <button class="btn btn-secondary btn-sm" @click="showSyncCloseConfirm = true">Close</button>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- Sync Status Close Confirmation Modal (match OltDetails) -->
    <div v-if="showSyncCloseConfirm">
      <div class="popup_bg"></div>
      <div class="modal_class">
        <div class="modal-content invoice" style="width:25vw">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="font-weight-bold">Confirm Close</span>
            <span @click="showSyncCloseConfirm = false" class="close">&times;</span>
          </div>
          <div class="my-3">
            Are you sure you want to close the Sync Status popup?
          </div>
          <div class="d-flex justify-content-end" style="gap: 10px;">
            <button class="btn btn-secondary btn-sm" @click="showSyncCloseConfirm = false">Cancel</button>
            <button class="btn btn-danger btn-sm" @click="closeSyncStatusModal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import oltDataPortList from "../services/oltDataPortList.service";
import getData from "../services/get-data.service";
import updatesData from "../services/update-data.service";
import deleteData from "../services/delete-data.service";
import rebotData from "../services/rebotData.service";
import Skalaton from "@/components/Skalaton.vue";
import showSwal from "/src/mixins/showSwal.js";
import dataList from "../services/data_list.service";
import { hasPermission } from "@/utils/permissions.js";
import { useOltDetailsApi } from "../services/olt_details.service";
export default {
  name: "Users",
  components: {
    Skalaton,
  },
  data() {
    return {
      splitData: [],
      sortKey: "",
      sortOrder: "asc",
      data: [],
      single_data_id: "",
      filteredData: [],
      filter_port_olt: [],
      filterOlt: [],
      port_olt: [],
      selected_olt: "",
      selected_port: "",
      searchQuery: "",
      statusFilter: "",
      reasonFilter: "",
      delete_id: "",
      currentPage: 1,
      itemsPerPage: 20,
      filter: [],
      reset_load: false,
      data_load: false,
      epon_popup: false,
      loading: false,
      delete_popup: false,
      load_index: "",
      formData: {
        PPPOE_ID: "",
        port_number: "",
      },
      olt_connect_id: "",
      showConfirm: false,
      syncing: false,
      syncMessage: "",
      sync_list: null,
      selectedSync: "",
      showSyncStatus: false,
      syncStatusMsg: null,
      syncStatusTimer: null,
      syncStatusCountdown: null,
      syncStatusHistory: [],
      syncStatusPollingActive: false,
      showSyncCloseConfirm: false,
      clearing: false,
    };
  },
  async mounted() {
    await this.filterData();
    if(this.filterOlt[0]?.id){
      this.selected_olt = this.filterOlt[0]?.id
    }
    
    if(this.selected_olt){
      await this.getData(this.selected_olt);
      // await this.getData(this.selected_olt);
      this.handleOltData()
    }
    
    this.syncList();
  },
  methods: {
    hasPermission,
    formatdata(data) {
      return (this.splitData = data.split(","));
    },

    async filterData() {
      const response = await dataList.getDataList();
      this.filterOlt = response;
    },

    async syncList() {
      try {
        const response = await useOltDetailsApi().oltSyncList();
        this.sync_list = response;
      } catch (error) {
        console.error("Error fetching sync list:", error);
      }
    },

    async Reset(port, id, index) {
      this.reset_load = true;
      this.load_index = index;
      const response = await rebotData.rebotData(port, id);
      if (response.status == "200") {
        showSwal.methods.showSwal({
          type: "success",
          message: "Reboot Successfully",
        });
      }
      this.reset_load = false;
    },

    async getResetData(port, id, index) {
      this.data_load = true;
      this.load_index = index;

      try {
        const response = await getData.getData(port, id);

        Swal.fire({
          icon: "success",
          title: "dBm " + response.dBm,
          timer: 9000,
          timerProgressBar: true,
          showConfirmButton: false,
          background: "#17ad37",
          color: "#fff",
        });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Error fetching data",
          timer: 5000,
          timerProgressBar: true,
          showConfirmButton: false,
          confirmButtonText: "Close",
          background: "#17ad37",
          color: "#fff",
        });
      } finally {
        this.data_load = false;
      }
    },

    async handleOltData ()  {
      if (this.selected_olt == "") {
       await this.getData();
        this.port_olt = [];
      } else {
        this.olt_connect_id = this.selected_olt;
        await this.getData(this.selected_olt);
        this.currentPage = 1;
        console.log(this.filter_port_olt);

        this.port_olt = this.filter_port_olt.filter(
          (item) => item.OLT_NAME === this.filterOlt.filter((item) => item.id == this.selected_olt)[0].olt_name
        );
      }
    },
    handlePortData(port) {
      this.recomputeFilters();
    },
    setStatusFilter(val) {
      // Toggle current status; always clear reason filter so filters are not combined
      this.statusFilter = this.statusFilter === val ? "" : val;
      this.reasonFilter = "";
      this.recomputeFilters();
    },
    setReasonFilter(val) {
      // Toggle current reason; always clear status filter so filters are not combined
      this.reasonFilter = this.reasonFilter === val ? "" : val;
      this.statusFilter = "";
      this.recomputeFilters();
    },
    recomputeFilters() {
      // Start from all data
      let base = [...this.data];
      // OLT filter
      if (this.selected_olt) {
        const selectedOltName = this.filterOlt.filter((item) => item.id == this.selected_olt)[0]?.olt_name;
        if (selectedOltName) {
          base = base.filter((item) => item.olt_connect === selectedOltName);
        }
      }
      // PORT filter
      if (this.selected_port) {
        base = base.filter((item) => {
          const [itemPort] = String(item.port_number || '').split(":");
          return itemPort === this.selected_port;
        });
      }
      // Status filter
      if (this.statusFilter) {
        base = base.filter((item) => String(item.status_is).toLowerCase() === this.statusFilter.toLowerCase());
      }
      // Reason filter
      if (this.reasonFilter) {
        base = base.filter((item) => item.last_dereg_reason === this.reasonFilter);
      }
      // Search filter
      if (this.searchQuery) {
        const q = this.searchQuery.toLowerCase();
        base = base.filter((item) => {
          for (let key in item) {
            if (String(item[key]).toLowerCase().includes(q)) return true;
          }
          return false;
        });
      }
      this.filteredData = base;
      this.filter = base;
      this.currentPage = 1;
    },

    async getData(params) {
      const response = await oltDataPortList.getOltDataPort(params);
      this.filter = this.data;
      this.data = response.olt_all_data;
      this.filter_port_olt = response.filter_port_olt;
      this.filteredData = response.olt_all_data;
    },

    async submitForm() {
      this.loading = true;
      try {
        await updatesData.updatesData(this.formData, this.single_data_id);
        await this.getData(this.olt_connect_id);
        this.popup_close();

        showSwal.methods.showSwal({
          type: "success",
          message: "Updated Successfully!",
        });
      } catch (error) {
        this.loading = false;
        console.error("Error on update:", error);
        showSwal.methods.showSwal({
          type: "error",
          message: "Failed to Create!",
        });
      }
    },
    async deletePopup(id) {
      if (!this.hasPermission("2024")) {
        showSwal.methods.showSwal({
          type: "error",
          message: "You do not have permission to perform this action.",
        });
        return;
      }
      this.delete_id = id;
      this.delete_popup = true;
    },
    async deleteItem() {
      this.loading = true;
      try {
        await deleteData.deleteData(this.delete_id);

        showSwal.methods.showSwal({
          type: "success",
          message: "Deleted Successfully!",
        });

        this.delete_popup = false;

        await this.getData(this.olt_connect_id);
      } catch (error) {
        this.loading = false;
        console.error("Error on delete:", error);
        showSwal.methods.showSwal({
          type: "error",
          message: "Failed to delete!",
        });
      }
    },

    popup_close() {
      this.delete_popup = false;
      this.epon_popup = false;
      this.formData.PPPOE_ID = "";
      this.formData.port_number = "";
    },
    setEdit(data) {
      if (!this.hasPermission("2024")) {
        showSwal.methods.showSwal({
          type: "error",
          message: "You do not have permission to perform this action.",
        });
        return;
      }
      this.epon_popup = true;
      this.single_data_id = data.id;
      this.formData.PPPOE_ID = data.PPPOE_ID;
      this.formData.port_number = data.port_number;
    },
    sort(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortKey = key;
        this.sortOrder = "asc";
      }

      this.filteredData.sort((a, b) => {
        const valueA = a[key] ? a[key].toString().toLowerCase() : "";
        const valueB = b[key] ? b[key].toString().toLowerCase() : "";
        const comparison = valueA.localeCompare(valueB);

        // Apply sort order based on the current state
        return this.sortOrder === "asc" ? comparison : -comparison;
      });
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    async handleSync() {
      if (this.syncing) return;
      this.syncing = true;
      if (this.syncStatusTimer) {
        clearTimeout(this.syncStatusTimer);
        this.syncStatusTimer = null;
      }
      this.syncStatusPollingActive = true;
      // Clear history at the start of a new sync
      this.syncStatusHistory = [];
      const selectedInfo = this.filterOlt.find(item => item.id == this.selected_olt);
      const oltid = selectedInfo?.oltid;
      try {
        // Always fetch details to get proper string brand/mode like in OltDetails
        const details = await useOltDetailsApi().oltDetails(oltid);
        const olt_brands = details?.olt_brands || String(selectedInfo?.olt_brands || '').trim();
        const olt_modes = details?.olt_modes || String(selectedInfo?.olt_modes || '').trim();

        if (!this.selectedSync) {
          // Sync All
          await useOltDetailsApi().oltSyncAll(oltid, olt_brands, olt_modes);
        } else {
          // Sync specific file
          await useOltDetailsApi().oltSync(oltid, olt_brands, this.selectedSync, olt_modes);
        }
        showSwal.methods.showSwal({
          type: 'success',
          message: 'Sync successful!',
        });
        await this.getData(this.selected_olt);
      } catch (error) {
        showSwal.methods.showSwal({
          type: 'error',
          message: error?.message || 'Sync failed!',
        });
        console.error(error);
      } finally {
        // After sync, call oltSyncStatus and show its response in a custom modal
        const pollStatus = async () => {
          if (!this.syncStatusPollingActive) return;
          try {
            const status = await useOltDetailsApi().oltSyncStatus(oltid);
            // Only add to history if different from last
            const last = this.syncStatusHistory[this.syncStatusHistory.length - 1];
            if (
              !last ||
              last.status !== status.status ||
              last.message !== status.message
            ) {
              this.syncStatusHistory.push({ ...status, timestamp: new Date() });
            }
            this.syncStatusMsg = status;
            this.showSyncStatus = true;
            if (this.syncStatusMsg.status === 'running' && this.syncStatusPollingActive) {
              this.syncStatusTimer = setTimeout(pollStatus, 5000);
            } else if (this.syncStatusMsg.status === 'finished') {
              // If finished, show countdown and wait 5 seconds, then reload data and close modal
              this.syncStatusCountdown = 10;
              const countdownInterval = setInterval(() => {
                this.syncStatusCountdown--;
                if (this.syncStatusCountdown <= 0) {
                  clearInterval(countdownInterval);
                }
              }, 1000);
              this.syncStatusTimer = setTimeout(async () => {
                await this.getData(this.selected_olt);
                this.showSyncStatus = false;
                this.syncStatusTimer = null;
                this.syncStatusCountdown = null;
                this.syncStatusHistory = []; // Optionally clear history on close
              }, 10000);
            } else if (this.syncStatusMsg.status === 'error') {
              // Stop polling on error
              this.syncStatusTimer = null;
            }
          } catch (e) {
            this.syncStatusMsg = { message: 'Failed to fetch sync status.', status: 'error' };
            this.showSyncStatus = true;
            this.syncStatusTimer = null;
          }
        };
        pollStatus();
        this.syncing = false;
      }
    },
    async handleClear() {
      if (!this.selected_olt) {
        showSwal.methods.showSwal({
          type: "error",
          message: "Please select an OLT first.",
        });
        return;
      }
      this.showConfirm = true;
    },
    async confirmClear() {
      if (this.clearing) return;
      this.clearing = true;
      try {
        const selectedInfo = this.filterOlt.find(item => item.id == this.selected_olt);
        const oltid = selectedInfo?.oltid;
        await useOltDetailsApi().oltClear(oltid);
        await this.getData(this.selected_olt);
        this.showConfirm = false;
      } catch (error) {
        this.showConfirm = false;
      } finally {
        this.clearing = false;
      }
    },
    closeSyncStatusModal() {
      this.showSyncStatus = false;
      this.syncStatusHistory = [];
      this.showSyncCloseConfirm = false;
      this.syncStatusPollingActive = false;
      if (this.syncStatusTimer) {
        clearTimeout(this.syncStatusTimer);
        this.syncStatusTimer = null;
      }
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.filteredData.length / this.itemsPerPage);
    },
    paginatedData() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredData.slice(
        startIndex,
        startIndex + this.itemsPerPage
      );
    },
  },
  watch: {
    searchQuery() { this.recomputeFilters(); },
    selected_olt() { this.recomputeFilters(); },
    selected_port() { this.recomputeFilters(); },
    statusFilter() { this.recomputeFilters(); },
    reasonFilter() { this.recomputeFilters(); },
  },
};
</script>

<style>
td {
  padding: 12px 24px !important;
}
.sort-icon {
  margin-left: 5px;
}

.asc::after {
  content: "▲";
}

.desc::after {
  content: "▼";
}

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: bold;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 50%;
  background-color: #40c133; /* or any other color you prefer */
  color: #fff; /* text color */
}
.modal_class {
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #181f2a !important;
  opacity: 0.93;
}

.popup_bg {
  opacity: 0.5;
}

.modal-content {
  background-color: #fff;
  max-width: 500px;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
}

.denger-bg {
  background-color: #dc3545 !important;
  color: white !important;
}

.denger-bg:hover {
  background-color: #c82333 !important;
}

.cursor-pointer {
  cursor: pointer;
}

.text-warning {
  color: #ffc107 !important;
}

.close {
  cursor: pointer;
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  margin-left: 16px;
}

.close:hover {
  color: #aaa;
}

.sync-history {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 10px;
}

/* Responsive controls row similar to OltDetails */
.olt-controls-row {
  gap: 12px;
}
@media (max-width: 900px) {
  .olt-controls-row {
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 10px;
  }
  .olt-controls-row > * {
    width: 100% !important;
    min-width: 0 !important;
    margin-bottom: 6px;
  }
}

</style>
